import { useEffect, useRef } from "react";
import ReactDOMServer from "react-dom/server";
import L from "leaflet";
import styled from "styled-components";
import "./leaflet.css";
// import { formatDuration, intervalToDuration } from "date-fns";
import { fromJS } from "immutable";
import { MapPinIcon } from "@heroicons/react/24/outline";

const StyledMap = styled.div<any>`
  height: ${(props) => props.appHeight}px !important;
  width: 100%;

  .leaflet-tooltip {
    padding: 0;
    border: none;
    top: -30px;

    &:before {
      content: unset;
    }
  }
  .leaflet-div-icon {
    background: none;
    border: 0px;
    .marker {
      &:hover {
        margin-top: -3px;
      }
    }
  }
  .leaflet-tooltip-top {
    width: 260px;
  }
`;
const BookingIcon: any = L.DivIcon.extend({
  options: {
    iconSize: [16, 16],
  },
});

// const MarkerIcon: any = L.DivIcon.extend({
//   options: {
//     iconSize: [25, 25],
//   },
// });

// function humanDuration(time: number) {
//   return formatDuration(intervalToDuration({ start: 0, end: time * 1000 }), {
//     format: ["days", "hours", "minutes"],
//   });
// }

function Map({ items, center = {}, appHeight }: any) {
  // create map
  const mapRef = useRef<any>(null);

  // create map route
  // const mapRouteRef = useRef<any>(null);

  // create layer
  // const layerRef = useRef<any>(null);

  // create layer
  const viewTrackingLayerRef = useRef<any>(null);

  // create tooltip
  // const tooltipRef = useRef<any>(null);

  // const handleMarkerHoverIn = ({ marker, type = "" }: any) => {};

  // const renderMakerPopup = ({ marker, type }: any) => {
  //   return "";
  // };

  // const StyledCenterMarker = styled.div<any>`
  //   .image-item {
  //     border-radius: 50% 50% 0 50%;
  //     animation: ripple 1.6s linear 3;
  //   }

  //   .image-item::after {
  //     content: "";
  //     transform: rotate(-45deg);
  //     overflow: hidden;
  //     border-radius: 50%;
  //     background-size: contain;
  //     background-position: center;
  //     background-repeat: no-repeat;
  //   }

  //   img {
  //     margin-top: ${(props) => props.myPossition}px;
  //     margin-left: ${(props) => props.myPossition}px;
  //   }
  //   .image-item {
  //     margin-top: ${(props) => props.myPossition}px;
  //     margin-left: ${(props) => props.myPossition}px;
  //   }

  //   @keyframes ripple {
  //     0% {
  //       box-shadow: 0 0 0 0rem rgba(255, 255, 255, 0.2);
  //     }
  //     100% {
  //       box-shadow: 0 0 0 3rem rgb(59, 130, 246, 0.5);
  //     }
  //   }
  // `;

  // const renderCenterMarker = (center: any) => {
  //   const htmlContent = ReactDOMServer.renderToStaticMarkup(
  //     <StyledCenterMarker className={"static"} myPossition={-30}>
  //       <div className="image-item origin-center rotate-45 absolute w-16 h-16 bg-blue-700 rounded-t-full rounded-bl-full"></div>
  //       <img
  //         className={"w-16 h-16 rounded-full absolute"}
  //         src={`${getStaticUrl()}/booking.png`}
  //       />
  //     </StyledCenterMarker>
  //   );
  //   return new MarkerIcon({ html: htmlContent });
  // };

  // const getStaticUrl = () => {
  //   return "/static";
  // };

  const renderMarkerIcon = (marker: any) => {
    const htmlContent = ReactDOMServer.renderToStaticMarkup(
      <div className="marker rounded-sm w-fit h-9 flex hover:bg-blue-900 hover:scale-110 bg-blue-700 text-white items-center p-2">
        <div className="">
          <MapPinIcon className={"w-4"} />
        </div>
        <div className="items-center font-semibold pl-2">
          {marker.getIn(["data", "city", "value"])},{marker.getIn(["data", "country", "value"])}
        </div>
      </div>
    );
    return new BookingIcon({
      html: htmlContent,
    });
  };

  const itemsGroupBy = (fieldId: string) => {
    return items.groupBy((groupItem: any) => groupItem.getIn(["data", fieldId]));
  };

  const renderActivities = () => {
    if (viewTrackingLayerRef.current) {
      viewTrackingLayerRef.current.clearLayers();
    }
    viewTrackingLayerRef.current = L.layerGroup().addTo(mapRef.current);

    itemsGroupBy("location").forEach((locations: any) => {
      const firstLocation = locations.first();
      const coordinates =
        firstLocation.getIn(["data", "location", "value", "coordinates"]) || fromJS([]);
      const latLng = { lat: coordinates.last(), lng: coordinates.first() };
      L.marker(latLng, {
        title: firstLocation.getIn(["data", "city", "value"]),
        icon: renderMarkerIcon(firstLocation),
      })
        .addTo(viewTrackingLayerRef.current)
        .on("mouseover", () => {
          // handleMarkerHoverIn({ marker: firstLocation, type: "" });
        });
    });
  };

  useEffect(() => {
    const { latitude, longitude } = center;
    if (mapRef.current) {
      mapRef.current.off();
      mapRef.current.remove();
    }
    mapRef.current = L.map("travelMap", {
      center: [latitude, longitude],
      zoom: 12,
      zoomControl: false,
      layers: [
        L.tileLayer("https://{s}.tile.osm.org/{z}/{x}/{y}.png", {
          attribution:
            '&copy; <a target="_blank" href="https://osm.org/copyright">OpenStreetMap contributors</a>',
        }),
      ],
    });
    L.control
      .zoom({
        position: "bottomright",
      })
      .addTo(mapRef.current);
  }, [appHeight]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    const { latitude, longitude } = center;
    mapRef.current.setView({ lat: latitude, lng: longitude });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // Add activity markers
  useEffect(() => {
    renderActivities();
  }, [items, appHeight]); // eslint-disable-line react-hooks/exhaustive-deps

  return <StyledMap id="travelMap" appHeight={appHeight} />;
}

export default Map;
